var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-box"},[(_vm.check)?_c('img',{staticClass:"check-img",attrs:{"src":require("@/assets/images/icons/checkbox-1.png")}}):_c('img',{staticClass:"check-img",attrs:{"src":require("@/assets/images/icons/checkbox-1.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }